import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function RangeValues(props) {
  const renderRange = () => (
    <div className={`${style.minmax_wrapper} ${props.className}`}>
      {props.range.map((item)=><span tabIndex={0}>{item}</span>)}
    </div>
  );
  const renderDisplay = () => {
    switch (props.valueType) {
      case 'precise':
        return renderRange();
      case 'vague':
        return <div></div>;
      default:
        return renderRange();
    }
  };
  return renderDisplay();
}

RangeValues.propTypes = {
  /**
   * value to be displayed
   */
  range: PropTypes.array,
  /**
   * classname
   */
  className: PropTypes.string,
};
